import React from 'react';

import { Typography } from '@sravni/react-design-system';

import { IServiceOption } from '../../../../../interfaces/reviews';
import { useProductsList } from '../../../../../store/hooks/products';
import { IProductsModalProps } from '../index';
import styles from '../products-modal.module.scss';

import { ProductLink } from './Link';
import { getSpecialStructurForServices } from './utils';

export interface IProductsListProps
  extends Pick<IProductsModalProps, 'type' | 'servicesOptions' | 'getTagLink' | 'isServicePage'> {
  currentService: IServiceOption;
  handleSetService: (value) => void;
}

export const ProductsList = ({
  type,
  currentService,
  servicesOptions,
  getTagLink,
  isServicePage,
  handleSetService,
}: IProductsListProps) => {
  const products = useProductsList();
  const servicesList = (currentService ? products[currentService.value] : servicesOptions) as IServiceOption[];
  const currentList = getSpecialStructurForServices(servicesList);

  return (
    <div className={servicesList?.length > 10 ? styles.contentInnerCols : styles.contentInner}>
      {currentList.length > 0 ? (
        <>
          {currentList.map((item, i) => {
            const key = Object.keys(item)[0];
            return (
              <div key={`products-list-${key}-${item.legalValue}`}>
                <Typography.Text size={16} strong className={`h-color-D40 h-pb-16 ${i > 0 ? 'h-pt-16' : ''}`}>
                  {key}
                </Typography.Text>
                {item[key].map((service) => (
                  <ProductLink
                    key={`products-list-${service.value || service.id}`}
                    currentService={currentService}
                    getTagLink={getTagLink}
                    isServicePage={isServicePage}
                    handleSetService={handleSetService}
                    product={service}
                    products={products}
                  />
                ))}
              </div>
            );
          })}
        </>
      ) : (
        <>
          {servicesList?.map((service) => (
            <ProductLink
              key={`products-${currentService?.value || type}-${service.value || service.id}`}
              currentService={currentService}
              getTagLink={getTagLink}
              isServicePage={isServicePage}
              handleSetService={handleSetService}
              product={service}
              products={products}
            />
          ))}
        </>
      )}
    </div>
  );
};
